/* eslint-disable import/no-unresolved, react/no-unused-state */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Catalog from '@mysidewalk/react-components/Catalog';

import {
  ALGOLIA_APPLICATION_ID,
  ALGOLIA_API_KEY,
  ALGOLIA_DIMENSIONS_INDEX,
  API_DOMAIN,
} from 'settings';
import { trackEvent } from 'application/analyticsManager';
import ApplicationContext from 'application/ApplicationContext';

const {
  Search: DataSelectionSearch,
  Context: DataSelectionContext,
  Controller: DataSelectionController,
} = Catalog;

const propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
};

const defaultProps = {
  onClick: null,
  className: '',
};

function CatalogLink({
  onClick,
  children,
  to,
  className,
  ...props
}) {
  const Comp = to ? Link : 'span';
  const classNames = to ? className : `${className} DimensionHit-button--no-link`;
  return (
    <Comp
      {...props}
      className={classNames}
      to={to}
    >
      {children}
    </Comp>
  );
}

CatalogLink.propTypes = propTypes;
CatalogLink.defaultProps = defaultProps;

const contextType = ApplicationContext;

class CatalogSearchRoute extends React.Component {
  constructor() {
    super();
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      opts: { hideIcons: true, hideSourceLink: true },
      settings: {
        ALGOLIA_APPLICATION_ID,
        ALGOLIA_API_KEY,
        ALGOLIA_DIMENSIONS_INDEX,
        API_DOMAIN,
      },
    };

    this.onAvailabilityClick = this.onAvailabilityClick.bind(this);
  }

  componentDidMount() {
    document.title = 'Search | mySidewalk Catalog';
    const controller = new DataSelectionController(
      {
        ALGOLIA_APPLICATION_ID,
        ALGOLIA_API_KEY,
        ALGOLIA_DIMENSIONS_INDEX,
        API_DOMAIN,
      },
      {
        onChangeState: this.setState.bind(this),
        onAvailabilityClick: this.onAvailabilityClick,
      },
      { hideIcons: true, hideSourceLink: true },
    );
    controller.setSelectionElement(CatalogLink);
    this.setState(controller);
  }

  onAvailabilityClick({ source }) {
    trackEvent('availability viewed', { source });
  }

  render() {
    return (
      <div style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
        <DataSelectionContext.Provider value={this.state}>
          <DataSelectionSearch />
        </DataSelectionContext.Provider>
      </div>
    );
  }
}

CatalogSearchRoute.contextType = contextType;

export default CatalogSearchRoute;
